import React from "react";
import avatar from "../../assets/avatar.png";
import { ChatList } from "../../utils/tools/chat";
const ChatBox = ({ setOpenDrawer }) => {
  return (
    <>
      <div className="mono_chatBox">
        <div className="title">
          <h2>chat list</h2>
        </div>
        <div className="chating_list">
          <ul>
            {ChatList.map((d) => (
              <li key={d.id} onClick={() => setOpenDrawer(false, d.id)}>
                <div className="image">
                  <img src={avatar} width="100%" alt="avatar" />
                  <span
                    style={{
                      backgroundColor: `${d.status ? "#31cc46" : "#cc4331"}`,
                    }}
                  ></span>
                </div>
                <div className="chating_content">
                  <h2>{d.name}</h2>
                  <p>
                    {d.status
                      ? "online"
                      : "left 8 mins ago"}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default ChatBox;
